import XlsxUploadCard from "./XlsxUploadCard";

/**
 * Facturación (Ventas) upload card. Thin wrapper over the generic
 * XlsxUploadCard configured for the /admin/sales/upload-xlsx endpoint.
 */
export default function SalesUploadCard({ onUploaded }) {
  return (
    <XlsxUploadCard
      kind="sales"
      endpoint="/admin/sales/upload-xlsx"
      title="Facturación (Ventas)"
      description={<>Sube el archivo <strong>Data Facturacion.xlsx</strong> (sheet &quot;Export&quot;). Cada fila representa una factura identificada por <code>(Factura, Chasis)</code>. El proceso corre en segundo plano — puedes cerrar esta pantalla.</>}
      resultKeys={{
        insertedLabel: "Insertadas",
        updatedLabel: "Actualizadas",
        totalKey: "total_sales_after",
        totalLabel: "Total en DB",
      }}
      testid="sales-upload-card"
      showModeSelector
      defaultMode="append"
      onUploaded={onUploaded}
    />
  );
}
